import { useGetDmcByCountryCurrencyQuery, useGetDmcQuery } from 'api';

export const useGetDmcByCountryCurrency = ({ countryCode, currency, onSuccess }) => {
  const query = useGetDmcByCountryCurrencyQuery({ countryCode, currency, onSuccess });
  let dmcList = [];
  if (query.isFetched) {
    dmcList = query?.data;
  }
  return {
    ...query,
    dmcList,
  };
};

export const useGetDmc = () => {
  const query = useGetDmcQuery();
  let dmcList = [];
  if (query.isFetched) {
    dmcList = query?.data?.data;
  }
  return {
    ...query,
    dmcList,
  };
};
